import { inject, Injectable } from '@angular/core';
import { FirestoreService } from '../../firestore.service';
import { from, Observable } from 'rxjs';
import { FIRESTORE_COLLECTIONS } from '../../firestore.constants';
import { Counter, CountersDocumentID } from './counters-collection.models';
import { COUNTER_FIELDS } from './counters-collection.constants';
import { DocumentData } from '@firebase/firestore';

@Injectable({
  providedIn: 'root',
})
export class CountersCollectionService {
  private readonly _firestoreService = inject(FirestoreService);

  public counterExists(documentId: CountersDocumentID): Observable<boolean> {
    return from(this._firestoreService.documentExists(FIRESTORE_COLLECTIONS.COUNTERS, documentId));
  }

  public createCounter(name: CountersDocumentID, count: number = 1): Observable<Counter> {
    return from(
      this._firestoreService.createDocument<Counter>({
        collectionName: FIRESTORE_COLLECTIONS.COUNTERS,
        id: name,
        data: {
          count: count,
        },
      }),
    );
  }

  public incrementCount(name: CountersDocumentID): Promise<Counter> {
    return this._firestoreService.runTransaction<Counter>(async (transaction) => {
      const counterRef = this._firestoreService.documentRef(FIRESTORE_COLLECTIONS.COUNTERS, name);
      const docSnapshot = await transaction.get(counterRef);
      const payload = {
        [COUNTER_FIELDS.COUNT]: 0,
      } as Counter;
      if (!docSnapshot.exists()) {
        transaction.set(counterRef, payload);
        payload.count += 1;
      } else {
        const counter = docSnapshot.data() as Counter;
        payload.count = counter.count + 1;
      }

      transaction.update(counterRef, payload as DocumentData);
      return payload;
    });
  }
}
